import { render, staticRenderFns } from "./MuraflexPage.vue?vue&type=template&id=7c9262a3&"
import script from "./MuraflexPage.vue?vue&type=script&lang=ts&"
export * from "./MuraflexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports